<script setup lang="ts">
import { computed } from 'vue';
import InputNumber from 'primevue/inputnumber';

interface Props {
  passengerData: object;
  totalPassenger: number;
  detailType: string;
  isCruise?: boolean;
}
const props = defineProps<Props>();

const emits = defineEmits<{ 'update:passengerData': [value: any] }>();

const passenger = computed({
  get() {
    return props.passengerData;
  },
  set(value) {
    emits('update:passengerData', value);
  }
});
</script>
<template>
  <div class="passenger_component">
    <div class="lg:col passenger_detail lg:mr-3 md:mr-3">
      <div class="flex justify-content-between align-items-center py-2">
        <div class="title font-bold">{{ $t('management.package.class') }}:</div>
        <div v-if="detailType == 'economy'">{{ $t('worksheet.economy') }}</div>
        <div v-else-if="detailType == 'business'">{{ $t('worksheet.business') }}</div>
      </div>
      <div class="flex justify-content-between align-items-center py-2">
        <div class="title font-bold">{{ $t('common.adults') }}:</div>
        <div v-if="isCruise">
          <InputNumber v-if="detailType == 'economy'" id="eco_adult" v-model="passenger.flights[0].adt" :min="0" :max="999" :allowEmpty="false" />
          <InputNumber v-else-if="detailType == 'business'" id="busi_adult" v-model="passenger.flights[0].businessAdt" :min="0" :max="999" :allowEmpty="false" />
        </div>
        <div v-else>
          <InputNumber v-if="detailType == 'economy'" id="eco_adult" v-model="passenger.adtNo" :min="0" :max="999" :allowEmpty="false" />
          <InputNumber v-else-if="detailType == 'business'" id="busi_adult" v-model="passenger.businessAdtNo" :min="0" :max="999" :allowEmpty="false" />
        </div>
      </div>
      <div class="flex justify-content-between align-items-center py-2">
        <div class="title font-bold">{{ $t('common.children') }}:</div>
        <div v-if="isCruise">
          <InputNumber v-if="detailType == 'economy'" id="eco_child" v-model="passenger.flights[0].chd" :min="0" :max="999" :allowEmpty="false" />
          <InputNumber v-else-if="detailType == 'business'" id="busi_child" v-model="passenger.flights[0].businessChd" :min="0" :max="999" :allowEmpty="false" />
        </div>
        <div v-else>
          <InputNumber v-if="detailType == 'economy'" id="eco_child" v-model="passenger.chdNo" :min="0" :max="999" :allowEmpty="false" />
          <InputNumber v-else-if="detailType == 'business'" id="busi_child" v-model="passenger.businessChdNo" :min="0" :max="999" :allowEmpty="false" />
        </div>
      </div>
      <div class="flex justify-content-between align-items-center py-2">
        <div class="title font-bold" v-if="detailType == 'economy'">{{ $t('book_form.total_economy') }}:</div>
        <div class="title font-bold" v-else-if="detailType == 'business'">{{ $t('book_form.total_business') }}:</div>
        <div class="total_style">{{ totalPassenger }}</div>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
.passenger_component {
  .passenger_detail {
    input {
      width: 50px;
      text-align: center;
    }
    .passenger_modal {
      padding-top: 20px;
    }
  }
}
@media screen and (max-width: 991px) {
  .passenger_modal {
    .card {
      padding: 2rem;
    }
  }
}
</style>
<style lang="scss" scoped>
.total_style {
  width: 50px;
  text-align: center;
}
@media screen and (max-width: 514px) {
  .business_class {
    margin-top: 20px;
  }
}
@media screen and (max-width: 544px) {
  .passenger_modal {
    .modal-container {
      justify-content: center;
    }
  }
}
</style>
